module.exports = __webpack_public_path__ + "img/2.ca3668c6.jpg";